import { Injectable, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';
import { filter } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private location = inject(Location);

  private history: string[] = [];
  private currentRouteSubject = new BehaviorSubject<any>(null);
  private _currentRoute$ = this.currentRouteSubject.asObservable();
  get currentRoute$(): Observable<any> {
    return this._currentRoute$;
  }

  constructor() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event) => {
      this.currentRouteSubject.next(this.resolveRoute().snapshot.data);
      return this.history.push(event.urlAfterRedirects);
    });
  }

  private resolveRoute(route = this.activatedRoute): ActivatedRoute {
    return route.firstChild ? this.resolveRoute(route.firstChild) : route;
  }

  async back(fallback = '/') {
    this.history.pop();
    if (this.history.length > 0) {
      this.location.back();
    } else {
      await this.router.navigateByUrl(fallback);
    }
  }
}
